var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D01C1F",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 2.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.5,
    width: 25,
    height: 2.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 25,
    height: 2.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22.5,
    width: 25,
    height: 2.5,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu4);
export default __webpack_public_path__ + "static/media/menu4.76a939ac.svg";
export { ForwardRef as ReactComponent };